export const toggleShowBalance = ({ commit, state }) => {
  commit("updateShowBalanceState", !state.showBalances);
};

export const setAppInstalled = ({ commit }, value) => {
  commit("updateAppInstalled", value);
};
